import React from 'react';
import {useNavigate} from 'react-router-dom';
import type {FetchVacancyResponse} from '@rocket-ui/lk-api';
import styles from './OfferPage.module.css';

interface OfferMobileHeroProps {
	vacancy: FetchVacancyResponse;
	title: string;
	price: string;
}

function BackIcon(): React.ReactElement {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
			<path d="M10 6L4 12L10 18" stroke="black" strokeWidth="1.6" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20 12.9135L5 12.9135L5 11.1992L20 11.1992L20 12.9135Z"
				fill="black"
			/>
		</svg>
	);
}

export function OfferMobileHero({vacancy, title, price}: OfferMobileHeroProps): React.ReactElement {
	const navigate = useNavigate();
	const status = vacancy.applied ? 'Вы откликнулись' : 'Новый';

	return (
		<div className={vacancy.applied ? `${styles.mobileHero} ${styles.mobileHeroWithApplied}` : styles.mobileHero}>
			<div className={styles.mobileHeroNav}>
				<button type="button" className={styles.mobileHeroBack} onClick={() => navigate(-1)} aria-label="Назад">
					<BackIcon />
				</button>
				<span className={styles.mobileHeroStatus}>{status}</span>
				<span className={styles.mobileHeroNavSpacer} aria-hidden />
			</div>

			{vacancy.invited && <span className={styles.mobileHeroInviteBadge}>Вас пригласили</span>}

			<h1 className={styles.mobileHeroTitle}>{title}</h1>
			<p className={styles.mobileHeroPriceRow}>
				<span className={styles.mobileHeroPrice}>{price}</span>
				<span className={styles.mobileHeroPriceHint}>до вычета налогов</span>
			</p>
		</div>
	);
}
